
const styles = {
    listItem: {
        
        padding: 10,
        borderRadius: 5,
        marginBottom: 5,
        boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px"
    } as React.CSSProperties,
};
export default styles;